import {
  PayeeRequirement,
  PayeeRequirementExpirationStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExpiringRequirements = (
  requirements: PayeeRequirement[]
) =>
  requirements.filter(
    e => e.expirationStatus === PayeeRequirementExpirationStatus.EXPIRING
  );
